import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";

const ERROR_MESSAGES = {
  store_already_connected:
    "Cette boutique est deja connectee a votre compte Teqa. Retrouvez-la dans la liste de vos integrations.",
  store_already_connected_with_other_teqa_store:
    "Cette boutique est deja rattachee a un autre compte store Teqa. Utilisez le compte proprietaire ou contactez le support pour demander un transfert.",
  invalid_or_expired_state:
    "La demande de connexion a expire ou n'est plus valide. Relancez la connexion depuis Teqa.",
  invalid_state:
    "La demande de connexion n'est plus valide. Relancez la connexion depuis Teqa.",
  missing_scope_read_products:
    "Shopify n'a pas autorise l'acces aux produits. Relancez la connexion et acceptez l'autorisation Produits.",
  token_service_unavailable:
    "La plateforme distante ne repond pas. Votre compte Teqa reste intact; reessayez dans quelques minutes.",
  token_exchange_failed:
    "La plateforme a refuse la finalisation. Verifiez les identifiants de l'application puis recommencez.",
  fetch_store_failed:
    "La connexion est autorisee, mais les informations de la boutique n'ont pas pu etre recuperees.",
  missing_code_or_state:
    "La plateforme n'a pas renvoye toutes les informations attendues. Relancez la connexion depuis Teqa.",
};

const platformLabel = (platform) => {
  if (String(platform).toLowerCase() === "youcan") return "YouCan";
  if (String(platform).toLowerCase() === "shopify") return "Shopify";
  return "la plateforme";
};

export default function IntegrationState() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const platform = searchParams.get("platform");
  const messageCode = searchParams.get("message") || "";
  const storeId = searchParams.get("store_id");
  const isSuccess = status === "success";
  const message = ERROR_MESSAGES[messageCode]
    || "La boutique n'a pas pu etre connectee. Relancez l'operation ou contactez le support si le probleme continue.";

  return (
    <div className="page-shell px-1 py-2">
      <header className="page-header-card">
        <p className="eyebrow">Integrations</p>
        <h1 className="mt-3 text-2xl font-semibold text-slate-950 dark:text-white">
          Etat de la connexion
        </h1>
      </header>

      <section className="surface-card mx-auto w-full max-w-2xl text-center">
        <div
          className={
            "mx-auto flex h-12 w-12 items-center justify-center rounded-lg "
            + (isSuccess
              ? "bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400"
              : "bg-amber-50 text-amber-600 dark:bg-amber-500/10 dark:text-amber-400")
          }
        >
          {isSuccess ? <CheckCircle2 size={24} /> : <AlertTriangle size={24} />}
        </div>

        <h2 className="mt-5 text-lg font-semibold text-slate-950 dark:text-white">
          {isSuccess
            ? platformLabel(platform) + " est maintenant connecte"
            : "Connexion " + platformLabel(platform) + " non terminee"}
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-600 dark:text-slate-300">
          {isSuccess
            ? "Les commandes et les produits autorises peuvent maintenant etre synchronises avec Teqa."
            : message}
        </p>

        {storeId ? (
          <p className="mt-4 break-all text-xs text-slate-400">Reference: {storeId}</p>
        ) : null}

        <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
          <button
            type="button"
            className="btn-primary"
            onClick={() => navigate(isSuccess ? "/integrations/products" : "/integrations/add")}
          >
            {isSuccess ? "Voir les produits" : "Relancer la connexion"}
          </button>
          <button
            type="button"
            className="btn-secondary"
            onClick={() => navigate("/integrations/list")}
          >
            Voir mes boutiques
          </button>
        </div>
      </section>
    </div>
  );
}
